import { render, staticRenderFns } from "./NewMoralShareholder.vue?vue&type=template&id=1a5edc8f"
import script from "./NewMoralShareholder.vue?vue&type=script&lang=js"
export * from "./NewMoralShareholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports